<app-header *ngIf="navbarVariant === 'legacy-header'"></app-header>
<app-shared-user-nav
  *ngIf="navbarVariant === 'shared-user'"
  [userRole]="navbarUserRole"
  [currentUrl]="currentUrl">
</app-shared-user-nav>
<app-corporate-admin-nav *ngIf="navbarVariant === 'corporate-admin'"></app-corporate-admin-nav>
<app-operator-nav *ngIf="navbarVariant === 'operator'"></app-operator-nav>
<app-executive-nav *ngIf="navbarVariant === 'executive'"></app-executive-nav>
<user-management-nav *ngIf="navbarVariant === 'user-management'"></user-management-nav>
<app-all-role-nav *ngIf="navbarVariant === 'all-role'"></app-all-role-nav>
  <app-dashboard-switcher *ngIf="(userRle == 2 || userRle == 12) && currentUrl !== '/user-management-sites' && visitedUserManagementSites"></app-dashboard-switcher>
  <section class="mt-5r p-1">
    <router-outlet></router-outlet>
  </section>
